import { SearchUrlParamBuilder } from '@/core/utils'
import axios from 'axios'

class DocumentosApiClient {
	constructor(urlBuilder) {
		this.urlBuilder = urlBuilder
	}

	async buscaPaginada(idEntidade, filtro, paginacao) {
		const url = SearchUrlParamBuilder.montarUrl(
			this.urlBuilder.getUrlBuscaPaginada(idEntidade),
			filtro,
			paginacao,
			true,
		)
		return await axios.get(url)
	}
	async excluir(idDocumento, filtro) {
		const url = SearchUrlParamBuilder.montarUrl(this.urlBuilder.getUrlExcluir(idDocumento), filtro)
		return await axios.delete(url)
	}
	async baixar(idDocumento, filtro) {
		const url = SearchUrlParamBuilder.montarUrl(this.urlBuilder.getUrlBaixar(idDocumento), filtro)

		return await axios.get(url, {
			responseType: 'arraybuffer',
		})
	}
	async cancelar(objCancelar) {
		const url = SearchUrlParamBuilder.montarUrl(this.urlBuilder.getUrlCancelar(objCancelar))
		return await axios.post(url, {
			motivoCancelamento: objCancelar.motivoCancelamento,
		})
	}
}

export default DocumentosApiClient
